<div class="flex flex-col">
  <div class="flex flex-col items-center h-full">
    <img src="assets/images/ks_logo.png" alt="Logo 1" class="h-11" />

    <a
      target="#"
      href="https://asgcare.dk/vores-samarbejdspartnere/"
      class="mt-4 text-sm underline font-inter text-[#2D3748] cursor-pointer"
      >Læs om Købstedernes forsikring</a
    >
    <!-- ############# -->

    <div
      class="flex items-center justify-center bg-[#F1FCF9] rounded-l-full rounded-r-full my-6"
    >
      <div
        (click)="togglePriceInterval()"
        [ngClass]="
          showYearlyPrice
            ? 'bg-[#072C29] text-[#F1FCF9] rounded-r-full'
            : 'bg-[#F1FCF9] text-[#072C29]'
        "
        class="font-inter w-32 text-center text-xs p-1 rounded-l-full cursor-pointer"
      >
        <span>Årlig</span>
      </div>
      <div
        (click)="togglePriceInterval()"
        [ngClass]="
          !showYearlyPrice
            ? 'bg-[#072C29] text-[#F1FCF9] rounded-l-full'
            : 'bg-[#F1FCF9] text-[#072C29]'
        "
        class="font-inter w-32 text-center text-xs p-1 rounded-r-full cursor-pointer"
      >
        <span>Månedlig</span>
      </div>
    </div>

    <!-- ############# -->

    <p *ngIf="showYearlyPrice" class="quantico-text text-8xl">
      {{ ksfPrice | formatNumber }}
    </p>

    <p *ngIf="!showYearlyPrice" class="quantico-text text-8xl">
      {{ ksfPrice / 12 | formatNumber }}
    </p>

    <p class="quantico-text text-4xl">DKK</p>

    <div class="m-5" *ngIf="ksfPriceLoading">
      <lib-loading-indicator size="10"></lib-loading-indicator>
    </div>

    <div
      class="text-center my-4"
      *ngIf="ksfPriceResult.state == 'Warnings' && !ksfPriceLoading"
    >
      <p class="font-semibold text-lg font-syne">Vi kan ikke beregne en pris</p>
      <p class="my-1 text-sm font-inter text-[#1F2937]">Hvad er årsagen?:</p>
      <p
        *ngFor="let msg of ksfPriceResult.applicationMessages"
        class="text-sm my-1"
      >
        {{ msg.message }}
      </p>
    </div>
  </div>
</div>
